/* eslint-disable */
import makeMutation from "@saleor/hooks/makeMutation";
import gql from "graphql-tag";

import {
  EmailSettingUpdate,
  EmailSettingUpdateVariables
} from "./types/EmailSettingUpdate";
import {
  emailSetDefaultTemplate,
  emailSetDefaultTemplateVariables
} from "./types/emailSetDefaultTemplate";
import { EmailSettingsDefaultCreate } from "./types/EmailSettingsDefaultCreate";

const emailSettingUpdate = gql`
  mutation EmailSettingUpdate($id: ID!, $input: EmailSettingUpdateInput!) {
    emailSettingUpdate(id: $id, input: $input) {
      errors {
        field
        message
      }
    }
  }
`;
export const useEmailSettingUpdateMutation = makeMutation<
  EmailSettingUpdate,
  EmailSettingUpdateVariables
>(emailSettingUpdate);

const emailSettingsDefaultCreate = gql`
  mutation EmailSettingsDefaultCreate {
    emailSettingsDefaultCreate {
      emailsettings {
        id
        name
        sendFrequency
        emailType
        template
        subject
        description
        lastChange
      }
      errors {
        field
        message
      }
    }
  }
`;
export const useEmailSettingsDefaultCreateMutation = makeMutation<
  EmailSettingsDefaultCreate,
  ""
>(emailSettingsDefaultCreate);

const emailSetDefaultTemplates = gql`
  mutation emailSetDefaultTemplate($id: ID!) {
    emailSetDefaultTemplate(id: $id) {
      emailsetting {
        id
        name
        sendFrequency
        emailType
        template
        subject
        description
        lastChange
      }
      errors {
        field
        message
      }
    }
  }
`;
export const useEmailSetDefaultTemplatesMutation = makeMutation<
  emailSetDefaultTemplate,
  emailSetDefaultTemplateVariables
>(emailSetDefaultTemplates);
